import React from "react";
import { notificationId as NotificationDataType } from "./NotifiationDataType";
// const NotificationDataType = require('./NotifiationDataType');

const AlertType = ({ item, getLangTranslation, moment }) => {
  // console.log(NotificationDataType)
  const notificationType = item?.type;
  let appOrWebBlock = "";

  if (notificationType === 127) {
    if (item?.notification?.includes("blocked app")) {
      appOrWebBlock = "APP";
    } else {
      appOrWebBlock = "WEB";
    }
  }

  let className = "";
  let iconClassName = "";
  let alertName = "";
  let alertText = "";
  // console.log(appOrWebBlock)
  if (appOrWebBlock) {
    // console.log(NotificationDataType[item?.type][appOrWebBlock === 'APP' ? 'type2' : 'type1'])
    className =
      NotificationDataType[item?.type][
        appOrWebBlock === "APP" ? "type2" : "type1"
      ]?.blockClassName;
    iconClassName =
      NotificationDataType[item?.type][
        appOrWebBlock === "APP" ? "type2" : "type1"
      ]?.iconClassName;
    alertName =
      NotificationDataType[item?.type][
        appOrWebBlock === "APP" ? "type2" : "type1"
      ]?.alertName;
    alertText =
      NotificationDataType[item?.type][
        appOrWebBlock === "APP" ? "type2" : "type1"
      ]?.alertText;
  } else {
    className = NotificationDataType[item?.type]?.blockClassName;
    iconClassName = NotificationDataType[item?.type]?.iconClassName;
    alertName = NotificationDataType[item?.type]?.alertName;
    alertText = NotificationDataType[item?.type]?.alertText;
  }

  // let msg = '';
  // for(let i = 0; i < item?.data_value?.length; i++) {
  //     if(item?.data_value[i]['key'] === '$MSG_TEXT$') {
  //         msg = item?.data_value[i]['value']
  //     }
  // }

  function convertText(text, item) {
    let convertedText = getLangTranslation(text);
    // console.log(convertedText)
    if (convertedText?.includes("$APP_NAME$")) {
      convertedText = convertedText?.replace("$APP_NAME$", item?.app_name);
    }
    if (convertedText?.includes("$CHILD_NAME$")) {
      convertedText = convertedText?.replace("$CHILD_NAME$", item?.name);
    }
    if (convertedText?.includes("$DEVICE_NAME$")) {
      convertedText = convertedText?.replace(
        "$DEVICE_NAME$",
        item?.device_name
      );
    }
    // console.log(convertedText)
    return convertedText;
  }

  return (
    <div className="g-col-12 g-col-md-6" id={item?.type}>
      <div className={`${className}`} role="alert">
        <div className="d-flex">
          <div className="d-flex align-items-start mt-1">
            <i className={iconClassName} />
          </div>
          <div className="mx-2">
            <span className="">{convertText(alertName, item)}</span>
            <p className="mb-0 text-small text-gray text-break">
              {alertText ? convertText(alertText, item) : item?.notification}
            </p>
            <div className="d-flex my-1">
              <p className="text-small mb-0 text-gray">
                {getLangTranslation("PARENT_NOTIFICATION_CHILD", "Child:")}
                <span className="text-blue-800 ms-1">{item?.childName}</span>
              </p>
              <p className="text-small mb-0 text-gray mx-3">
                {getLangTranslation("PARENT_NOTIFICATION_DEVICE", "Device:")}
                <span className="text-blue-800 ms-1">{item?.device_name}</span>
              </p>
            </div>
            <p className="text-small mb-0 text-gray">
              <span className="text-blue-800 ms-1">
                {moment(item?.created_date)
                  .utc()
                  .format("MMM DD, YYYY hh:mm A")}
              </span>
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
  );

  // switch (item?.alertType) {
  //     case "2": {

  //     }
  //     default:
  //         return null
  // }

  // return (
  //     <div className="alert alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-3" role="alert">
  //         <div className='d-flex align-items-center gap-1'>
  //             <i className='icon-monitor text-danger fs-5' />
  //             <span className='text-small text-gray'>Alert</span>
  //         </div>
  //         <h5 className='mb-0 text-blue-900'>Serious Permission disabled</h5>
  //         <p className='text-small mb-0 text-gray'>Child: <span className='text-blue-800 ms-1'>Emma</span></p>
  //         <p className='text-small mb-0 text-gray'>Device: <span className='text-blue-800 ms-1'>Samsung A50</span></p>
  //     </div>
  // )
};

export default AlertType;
